import { gql } from "@apollo/client";

const SAVE_REQUERIMIENTOS_ADICIONALES_VISITA_CD = gql`
mutation CreateAdicionalesVisita($input: AddVisitaCPAdicionalesInput!){
    createAdicionalVisita(input: $input){
        idAdicionalesVisita
    }
}`;

export const adaptAdicionalesVisitaInput = (data) => ({
  idVisita: data?.idVisita,
  idComboRIValorReqAdicional: data?.idComboRIValorReqAdicional || []
});

export default SAVE_REQUERIMIENTOS_ADICIONALES_VISITA_CD;